
// ================================
// pages/legal/LegalNotice.js
// ================================
import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

 const LegalNotice = () => (
  <div className="legal-page">
    <div className="legal-container">
      <div className="legal-header">
        <Link to="/" className="legal-back">← Back</Link>
        <h1>Legal Notice</h1>
        <p className="legal-date">Last updated: March 7, 2025</p>
      </div>

      <section>
        <h2>1. Website Publisher</h2>
        <p><strong>Company:</strong> SynexStudio</p>
        <p><strong>Location:</strong> Rouen, France</p>
        <p><strong>Email:</strong> <a href="mailto:synexstudio76@gmail.com">synexstudio76@gmail.com</a></p>
        <p><strong>Website:</strong> rizzingbot.com</p>
      </section>

      <section>
        <h2>2. Hosting</h2>
        <p><strong>Provider:</strong> Hetzner Online GmbH</p>
        <p><strong>Address:</strong> Industriestr. 25, 91710 Gunzenhausen, Germany</p>
        <p><strong>Website:</strong> <a href="https://www.hetzner.com" target="_blank" rel="noopener noreferrer">hetzner.com</a></p>
      </section>

      <section>
        <h2>3. Intellectual Property</h2>
        <p>All content published on RizzingBot is the property of SynexStudio and protected by French and international intellectual property laws. Any reproduction without prior written permission is strictly prohibited.</p>
      </section>

      <section>
        <h2>4. Personal Data</h2>
        <p>Personal data is processed in accordance with our <Link to="/privacy">Privacy Policy</Link> and the GDPR.</p>
        <p><strong>Data Controller:</strong> SynexStudio — <a href="mailto:synexstudio76@gmail.com">synexstudio76@gmail.com</a></p>
        <p>You have the right to contact the French data protection authority: <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">CNIL — cnil.fr</a></p>
      </section>

      <section>
        <h2>5. Applicable Law</h2>
        <p>This website and its contents are governed by French law. Any disputes shall be subject to the jurisdiction of the competent French courts.</p>
      </section>

      <div className="legal-footer">
        <Link to="/terms">Terms of Service</Link>
        <Link to="/privacy">Privacy Policy</Link>
        <Link to="/refund">Refund Policy</Link>
      </div>
    </div>
  </div>
);
export default LegalNotice;